import { createFileRoute, redirect } from "@tanstack/react-router";

import { HomePageRoute } from "../components/home/HomePageRoute";
import { WorkflowsPage } from "../components/workflows/WorkflowsPage";

/**
 * `/$org/workflows` — the organization's workflows, full width with no
 * sidebar beside it. Home's sidebar has a Workflows row linking here, and the
 * rail selects Workflows (components/home/homePaths).
 */
function WorkflowsRouteView() {
  return (
    <HomePageRoute>
      <WorkflowsPage />
    </HomePageRoute>
  );
}

export const Route = createFileRoute("/$org/workflows/")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  component: WorkflowsRouteView,
});
